import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("合同会签审批权限一览表")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("保存修改")
const _hoisted_3 = { style: {"text-align":"center","height":"800px"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("关闭")

import { reactive, ref, unref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router'

/* Npm 组件 */
import { isNull } from 'lodash';
import { ElMessage } from 'element-plus';

/* 自定义组件 */
import ContractWriter from '../components/0_ContractWriter.vue'
import { findIndex } from '../../../utils/index';

/* Apis */
import { EditContractApi } from '@/apis/contract/contract.api'

/* Types */
import type { ContractCreate } from '@/apis/contract/contract.type'
import { GbDialog } from '@/components/GbDialog/Index';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const images = require('@/assets/images/tapd_38273684_base64_1691112404_826.png')

const state = reactive({
    showPic: false
})

const { push } = useRouter()
const { query } = useRoute()

const loading = ref(false)
const writerRef = ref<ComponentRef<typeof ContractWriter>>()

/* 保存修改 */
const onSaveButtonClick = async () => {

    const writer = unref(writerRef)

    const isOk = await writer?.methods.checkFromData();

    /* 获取并保存数据 */
    if (isOk) {

        const editDto = writer?.methods.getFormData() as ContractCreate

        loading.value = true

        EditContractApi(editDto).then((res) => {

            if (res.succeeded) {

                ElMessage({ type: 'success', showClose: true, message: '合同修改成功。', })

                push('/contract/manage')

            }
            else {

                ElMessage({ type: 'error', showClose: true, message: `合同修改失败，原因：${res.errors}`, })

            }

        }).finally(() => { loading.value = false })

    }

};

onMounted(() => {

    unref(writerRef)?.methods.setFormData(query.contractId as string)

})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ContractWriter, {
      ref_key: "writerRef",
      ref: writerRef,
      showprogress: true,
      isEditor: true,
      titles: `编辑合同`
    }, {
      Options: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "warning",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(state).showPic = true))
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: onSaveButtonClick
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512),
    _createVNode(_unref(GbDialog), {
      modelValue: _unref(state).showPic,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).showPic) = $event)),
      title: "合同会签审批权限一览表",
      style: {"width":"800px"}
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          class: "w90",
          type: "info",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(state).showPic = false))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_image, {
            style: {"height":"100%"},
            src: _unref(images),
            "preview-src-list": [_unref(images)],
            fit: "fill"
          }, null, 8, ["src", "preview-src-list"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})